import GrayButton from "../../GrayButton";

export const ProjectDuplicateLink = ({
    projectName,
    onCancel
}) => {
    return (
        <div className="event-link" style={{padding: "12px"}}>
            <div className="flex justify-between">
                <div>
                    {projectName}
                </div>
                <div>
                    <GrayButton className="px-1.5" onClick={() => onCancel()}>
                        X
                    </GrayButton>
                </div>
            </div>
        </div>
    )
}

export default ProjectDuplicateLink
